import type { GetProjectById200BasicInfoVisibility } from './getProjectById200BasicInfoVisibility';

/**
 * 프로젝트 기본 정보
 */
export type GetProjectById200BasicInfo = {
  createdAt?: string;
  description?: string;
  /** 프로젝트 ID (Snowflake ID) */
  id?: number;
  title?: string;
  updatedAt?: string;
  visibility?: GetProjectById200BasicInfoVisibility;
};
